import { ComponentType } from 'react';

import { Dashboard } from '@ledium/ui-dashboard';
import { LightChannels, LightChannelsMainMenu } from '@ledium/ui-light-channels';
import { LightRecipes, LightRecipesMainMenu } from '@ledium/ui-light-recipes';
import { ProjectEditor, ProjectEditorMainMenu } from '@ledium/ui-project-editor';
import { RecipeEditor, RecipeEditorMainMenu } from '@ledium/ui-recipe-editor';
import { Settings } from '@ledium/ui-settings';
import { SpectrumMixer, SpectrumMixerMainMenu } from '@ledium/ui-spectrum-mixer';
import { Zones, ZonesMainMenu } from '@ledium/ui-zones';

export interface RouteConfig {
    pageName: string;
    path: string;
    hasZoneRoute?: boolean;
    Component: ComponentType;
    MenuComponent?: ComponentType;
}

export const routeConfig: RouteConfig[] = [
    {
        pageName: 'dashboard',
        path: '/',
        hasZoneRoute: true,
        Component: Dashboard
    },
    {
        pageName: 'settings',
        path: '/settings/:tabName?',
        Component: Settings
    },
    {
        pageName: 'zones',
        path: '/zones/:pageType(new|edit|view)?/:itemId?',
        MenuComponent: ZonesMainMenu,
        Component: Zones
    },
    {
        pageName: 'lightChannels',
        path: '/light-channels/:pageType(new|edit|view)?/:itemId?',
        hasZoneRoute: true,
        MenuComponent: LightChannelsMainMenu,
        Component: LightChannels
    },
    {
        pageName: 'spectrumMixers',
        path: '/spectrum-mixes/:pageType(new|edit|view)?/:itemId?',
        hasZoneRoute: true,
        MenuComponent: SpectrumMixerMainMenu,
        Component: SpectrumMixer
    },
    {
        pageName: 'projects',
        path: '/projects/:pageType(new|edit|view)?/:itemId?',
        hasZoneRoute: true,
        MenuComponent: ProjectEditorMainMenu,
        Component: ProjectEditor
    },
    {
        pageName: 'recipes',
        path: '/recipes/:pageType(new|edit|view)?/:itemId?',
        MenuComponent: RecipeEditorMainMenu,
        Component: RecipeEditor
    },
    {
        pageName: 'lightRecipes',
        path: '/light-recipes/:pageType(new|edit|view)?/:itemId?',
        MenuComponent: LightRecipesMainMenu,
        Component: LightRecipes
    }
];
